"use client";

import {
	faCircleChevronDown,
	faCircleChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setUserInteractionDataAttribute } from "@shared/constants";
import clsx from "clsx";
import type React from "react";
import { useState } from "react";

interface Props {
	children: React.ReactNode;
	className?: string;
	label: string;
	open?: boolean;
}

export default function Accordion({
	children,
	className,
	label,
	open = false,
}: Props) {
	const [isOpen, setIsOpen] = useState(open);

	const dataAttrGTM = setUserInteractionDataAttribute(
		`accordion-${label.toLowerCase().replace(/\s/g, "_")}`,
	);
	return (
		<details
			{...setUserInteractionDataAttribute(
				`accordion_${label}_details_summary_${isOpen ? "open" : "closed"}`,
			)}
			className={clsx("accordion", className)}
			{...dataAttrGTM}
		>
			<summary className="accordion__summary">
				<span className="accordion__summary__icon">
					<FontAwesomeIcon
						icon={isOpen ? faCircleChevronUp : faCircleChevronDown}
						onClick={() => setIsOpen(!isOpen)}
						data-testid="accordion-icon"
					/>
				</span>
				<span
					className="accordion__summary__text"
					onClick={() => setIsOpen(!isOpen)}
				>
					{label}
				</span>
			</summary>
			<div className="accordion__content">{children}</div>
		</details>
	);
}
